export default {
  floor: "όροφο",
  first_floor: "Πρώτο",
  semi_floor: "Ημιώροφο",
  mezzanine_floor: "Ημιώροφο",
  second_floor: "Δεύτερο",
  third_floor: "Τρίτο",
  fourth_floor: "Τέταρτο",
  fifth_floor: "Πέμπτο",
  ground_floor: "Ισόγειο",
  room: "Αίθουσα",
  rooms: "Αίθουσες",
  primary_building: "Βασικό Κτήριο",
  office_letter_a: "Α",
  office_letter_b: "Β",
  office_letter_c: "Γ",
  office_letter_d: "Δ",
  building_C: "Γ",
  building_D: "Δ",
  building_H: "Θ",
  building_G: "Η",
  building_K: "Κ",
  building_F: "Ζ",
  auditorium: "Αμφιθέατρο",
  auditoriums: "Αμφιθέατρα",
  student_groups: "Φοιτητικές Ομάδες",
  professor_offices: "Γραφεία Καθηγητών",
  technical_support: "Τεχνική Υπηρεσία",
  ergastirio_kid: "Εργαστήριο Κέντρου Η/Υ (ΚΥΔ)",
  office_kid: "Γραφείο Κέντρου Η/Υ και Δικτύων",
  ergasthrio_texnologikhs_ekpaideusis: "Εργαστήριο Τεχνολογικής Εκπαίδευσης",
  conference_room: "Αίθουσα Συνεδρίων",
  remote_education_room: "Αίθουσα Τηλεκπαίδευσης",
  secretaries: "Γραμματείες",
  other: "Άλλο",
  finance_secretary: "Γραμματεία Χρηματοοικονομικής και Λογιστικής",
  european_studies_secretary: "Γραμματεία Διεθνών και Ευρωπαϊκών Σπουδών",
  music_and_art_studies_secretary: "Γραμματεία Μουσικής Επιστήμης και Τέχνης",
  balkan_studies_secretary:
    "Γραμματεία Βαλκανικών, Σλαβικών και Ανατολικών Σπουδών",
  ekp_secretary: "Γραμματεία Εκπαιδευτικής και Κοινωνικής Πολιτικής",
  econ_secretary: "Γραμματεία Οικονομικών Σπουδών",
  internship_office_2: "Γραφείο Πρακτικής Άσκησης",
  //liaison_office:"Γραφείο Διασύνδεσης"
  student_care_office: "Γραφείο Φοιτητικής Μέριμνας",
  dai_secretary: "Γραμματεία Εφαρμοσμένης Πληροφορικής",
  ba_secretary: "Γραμματεία Οργάνωσης και Διοίκησης Επιχειρήσεων",
  library: "Βιβλιοθήκη",
  gym: "Γυμναστήριο",
  aiesec: "AIESEC",
  open_source_uom: "Κοινότητα Ανοιχτού Λογισμικού",
  student_restaurant: "Εστιατόριο Φοιτητών",
  cafeteria: "Κυλικείο",
  concierge: "Θυρωρείο",
  ceremony_hall_for_navigation: "01 (Τελετών)",
  //uni_publications:"Εκδόσεις ΠΑΜΑΚ"
  post_office: "Ταχυδρομείο",
  diatmimatika_metaptixiaka_secretary:
    "Διατμηματικών Μεταπτυχιακών Προγραμμάτων",
  photocopy_space: "Φωτοτυπείο",
  lab: "Εργαστήριο",
  depname_bso: "Βαλκανικών, Σλαβικών & Ανατολικών Σπουδών",
  depname_ies: "Διεθνών & Ευρωπαϊκών Σπουδών",
  depname_esp: "Εκπαιδευτικής & Κοινωνικής Πολιτικής",
  depname_dai: "Εφαρμοσμένης Πληροφορικής",
  depname_fin: "Λογιστικής και Χρηματοοικονομικής",
  depname_msa: "Μουσικής Επιστήμης & Τέχνης",
  depname_eco: "Οικονομικών Επιστημών",
  depname_ba: "Οργάνωσης & Διοίκησης Επιχειρήσεων",
  select_where_to_go: "Πού θέλετε να πάτε;",
  select_location: "Επιλέξτε τοποθεσία",
  virtual_tour: "Εικονική Περιήγηση",
  cant_find_building_prompt: "Δε γνωρίζετε πού βρίσκεται το κτήριο;",
  cant_see_room_prompt:
    "Σε περίπτωση που δε βλέπετε την αίθουσα μπορείτε να κάνετε zoom",
  closest_elevator_prompt:
    "Το κοντινότερο ασανσέρ σε σχέση με την αίθουσα είναι αυτό: ",
  //!
  enter_elevator_prompt: "Μπείτε σε αυτό το ασανσέρ και πηγαίνετε στον",
  see_room_again: "Ξαναδείτε πού είναι η αίθουσα",
};
